import { render, staticRenderFns } from "./FundingAssessmentsGrading.vue?vue&type=template&id=21564c84&"
import script from "./FundingAssessmentsGrading.vue?vue&type=script&lang=js&"
export * from "./FundingAssessmentsGrading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports